// extracted by mini-css-extract-plugin
module.exports = {"Project":"Project_Project__3UuOO","image":"Project_image__2HVVG","tech":"Project_tech__2hkcE","buttons":"Project_buttons__1jdLA","disabled":"Project_disabled__3fqIi"};